import { render, staticRenderFns } from "./RelacaoContratacoesEntregas.vue?vue&type=template&id=29455310"
import script from "./RelacaoContratacoesEntregas.vue?vue&type=script&lang=js"
export * from "./RelacaoContratacoesEntregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports